import { CellLayout, Dimension, Pagination } from "../video-types";
import { MediaStream, Participant, ZoomClient } from "../../../index-types";
import { MutableRefObject, useCallback, useEffect, useState } from "react";

import { getVideoLayout } from "../video-layout-helper";
import { useRenderVideo } from "./useRenderVideo";

/**
 * Default order of video:
 *  1. video's participants first
 *  2. self on the second position
 */
export function useGalleryLayout(
    zmClient: ZoomClient,
    mediaStream: MediaStream | null,
    isVideoDecodeReady: boolean,
    videoRef: MutableRefObject<HTMLCanvasElement | null>,
    dimension: Dimension,
    pagination: Pagination,
    isChangeResolution: boolean,
    setIsChangeResolution: (value: boolean) => void
) {
    const [visibleParticipants, setVisibleParticipants] = useState<Participant[]>([]);
    const [layout, setLayout] = useState<CellLayout[]>([]);
    const [subscribedVideos, setSubscribedVideos] = useState<number[]>([]);
    const { page, pageSize, totalPage, totalSize } = pagination;
    let size = pageSize;
    if (page === totalPage - 1) {
        size = Math.min(size, totalSize % pageSize || size);
    }

    const RestoredVideo = async (Videolayout: CellLayout[], participants: Participant[] | null, render: HTMLCanvasElement | null) => {
        if (isChangeResolution) {
            if (!participants)
                participants = zmClient.getAllUser();
            if (!render)
                render = document.querySelector('#video-canvas') as HTMLCanvasElement;
            let participant1Height = Videolayout[0].height;
            let participant1Width = Videolayout[0].width;
            let participant1X = Videolayout[0].x;
            let participant1Y = Videolayout[0].y;
            let participant1Quality = Videolayout[0].quality;

            let participant2Height = Videolayout[1].height;
            let participant2Width = Videolayout[1].width;
            let participant2X = Videolayout[1].x;
            let participant2Y = Videolayout[1].y;
            let participant2Quality = Videolayout[1].quality;

            await mediaStream?.adjustRenderedVideoPosition(render, participants[1].userId, participant1Width, participant1Height, participant1X, participant1Y);
            await mediaStream?.adjustRenderedVideoPosition(render, participants[0].userId, participant2Width, participant2Height, participant2X, participant2Y);
            setIsChangeResolution(false);
        }
    };

    useEffect(() => {
        setLayout(getVideoLayout(dimension.width, dimension.height, size));
    }, [dimension, size]);
    const onParticipantsChange = useCallback(() => {
        const participants = zmClient.getAllUser();
        const currentUser = zmClient.getCurrentUserInfo();
        //console.log("usersParticipantsChangeGallery", zmClient.getAllUser());
        if (currentUser && participants.length > 0) {
            let pageParticipants: any[] = [];
            if (participants.length === 1) {
                pageParticipants = participants;
            } else {
                console.log("Change participan");
                pageParticipants = participants
                    .filter((user) => user.userId !== currentUser.userId)
                    .sort((user1, user2) => Number(user2.bVideoOn) - Number(user1.bVideoOn));
                pageParticipants.splice(1, 0, currentUser);
                pageParticipants = pageParticipants.filter((_user, index) => Math.floor(index / pageSize) === page);
                if (isChangeResolution && participants.filter((user) => user.bVideoOn).length != 2) {
                    RestoredVideo(layout, null, null)
                }
            }
            setVisibleParticipants(pageParticipants);
            const videoParticipants = pageParticipants.filter((user) => user.bVideoOn).map((user) => user.userId);
            setSubscribedVideos(videoParticipants);
        }
    }, [zmClient, page, pageSize, isChangeResolution]);
    useEffect(() => {
        zmClient.on("user-added", onParticipantsChange);
        zmClient.on("user-removed", onParticipantsChange);
        zmClient.on("user-updated", onParticipantsChange);
        return () => {
            zmClient.off("user-added", onParticipantsChange);
            zmClient.off("user-removed", onParticipantsChange);
            zmClient.off("user-updated", onParticipantsChange);
        };
    }, [zmClient, onParticipantsChange]);
    useEffect(() => {
        onParticipantsChange();
    }, [onParticipantsChange]);

    useRenderVideo(
        mediaStream,
        isVideoDecodeReady,
        videoRef,
        layout,
        subscribedVideos,
        visibleParticipants,
        zmClient?.getCurrentUserInfo()?.userId
    );
    return {
        visibleParticipants,
        layout,
    };
}
